var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMatch0 = function SvgMatch0(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12H5.5C4.67157 12 4 12.6716 4 13.5V22.5C4 23.3284 4.67157 24 5.5 24H6.5C7.32843 24 8 23.3284 8 22.5V13.5C8 12.6716 7.32843 12 6.5 12Z",
    fill: "#D9DFE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.5C6.99967 22.776 6.77601 22.9997 6.5 23H5.5C5.22399 22.9997 5.00033 22.776 5 22.5V13.5C5.00033 13.224 5.22399 13.0003 5.5 13H6.5C6.77601 13.0003 6.99967 13.224 7 13.5V22.5Z",
    fill: "#D9DFE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7H12.5C11.6716 7 11 7.67157 11 8.5V22.5C11 23.3284 11.6716 24 12.5 24H13.5C14.3284 24 15 23.3284 15 22.5V8.5C15 7.67157 14.3284 7 13.5 7V7Z",
    fill: "#D9DFE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.5C13.9997 22.776 13.776 22.9997 13.5 23H12.5C12.224 22.9997 12.0003 22.776 12 22.5V8.5C12.0003 8.22399 12.224 8.00033 12.5 8H13.5C13.776 8.00033 13.9997 8.22399 14 8.5V22.5Z",
    fill: "#D9DFE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2H19.5C18.6716 2 18 2.67157 18 3.5V22.5C18 23.3284 18.6716 24 19.5 24H20.5C21.3284 24 22 23.3284 22 22.5V3.5C22 2.67157 21.3284 2 20.5 2Z",
    fill: "#D9DFE9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMatch0);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/match0.b66c0a478c247b2925c0651c765f0d91.svg";